<div
  class="d-flex justify-content-center loader flex-column align-items-center"
  *ngIf="loading"
>
  <div>
    <mat-spinner color="accent"></mat-spinner>
  </div>
</div>

<div class="main-wrapper py-5 px-3">
  <!-- Title / Search Section -->
  <div class="row m-0 justify-content-center mb-5">
    <div class="col-md-10 text-center">
      <h1 class="mat-display-2 font-weight-bold mb-2 text-dark">
        Find your trusted service provider
      </h1>
      <p class="mat-title text-muted mb-4">
        Your Exclusive Gateway to Visibility and Discovery across {{categoryCount || 'many'}} Categories!
      </p>
      
      <!-- Modern Search Bar -->
      <div class="col-md-9 mx-auto p-0">
        <form [formGroup]="searchCategoryForm" (ngSubmit)="search()">
          <div class="search-pill-container d-flex align-items-center">
            <fa-icon [icon]="faSearch" class="text-muted mr-3" size="lg"></fa-icon>
            <input 
              placeholder="Search by category name or keyword..." 
              class="searchInput flex-1 border-0" 
              name="searchPhrase" 
              formControlName="searchPhrase"
            />
            <button type="submit" mat-flat-button color="primary" class="search-btn text-white">
              SEARCH
            </button>
          </div>
        </form>

        <div class="d-flex justify-content-center p-3 align-items-center" *ngIf="searchPhrase">
          <p class="text-muted m-0"> Showing results for "{{searchPhrase}}" </p>
          <button type="button" (click)="clearSearch()" mat-stroked-button class="ml-3 rounded-pill">
            Clear Search
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Main Content Area -->
  <div class="row m-0 justify-content-center">
    <div class="col-md-10 p-0">
      
      <!-- Skeleton Loaders -->
      <ng-container *ngIf="!categories || categories.length < 1">
        <div class="row m-0">
          <div class="col-md-4 mb-4 col-sm-6 col-xs-12 p-2" *ngFor="let item of [1,2,3,4,5,6]">
            <app-ghost-rect></app-ghost-rect>
          </div>
        </div>
      </ng-container>

      <!-- Category Flip Cards List -->
      <ng-container *ngIf="categories && categories.length > 0 && !searchResult">
        <div class="row m-0">
          <div *ngFor="let category of categories" class="col-md-4 mb-4 col-sm-6 col-xs-12 p-2">
            <app-flip-card (emitOpen)="open($event)" (emitFollow)="goTo($event)" [category]="category"></app-flip-card>
          </div>
        </div>
      </ng-container>

      <!-- Search Results List -->
      <ng-container *ngIf="searchResult">
        <div class="row m-0">
          <div *ngFor="let category of searchResult" class="col-md-4 mb-4 col-sm-6 col-xs-12 p-2">
            <app-flip-card (emitOpen)="open($event)" (emitFollow)="goTo($event)" [category]="category"></app-flip-card>
          </div>
        </div>
      </ng-container>

    </div>
  </div>
</div>
